export default __webpack_public_path__ + "static/properties/20260316-200400.316/common_de.properties";